import script from "./ScanReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScanReport.vue?vue&type=script&setup=true&lang=ts"

import "./ScanReport.vue?vue&type=style&index=0&id=124d7bb4&scoped=true&lang=css"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124d7bb4"]])

export default __exports__